







































































import { Component, Vue } from 'vue-property-decorator';
import IconOrLoader from '@/components/svg/IconOrLoader.vue';
import UserService from '@/services/user';

@Component({
    components: {
        IconOrLoader,
    },
})
export default class PasswordReset extends Vue {
    userService = new UserService();

    password: string = null;

    passwordConfirmation: string = null;

    errors = {
        passwordsDoNotMatch: false,
        required: {
            password: false,
            confirmation: false,
        },
    };

    loading = false;

    passwordSaved = false;

    tokenValid: boolean = null;

    get token() {
        return this.$route.params.token;
    }

    mounted() {
        this.userService.checkResetPasswordToken(this.token)
            .then(() => {
                this.tokenValid = true;
            })
            .catch(() => {
                this.tokenValid = false;
            });
    }

    reset() {
        this.errors.required.password = !this.password;
        this.errors.required.confirmation = !this.passwordConfirmation;
        this.errors.passwordsDoNotMatch = this.password !== this.passwordConfirmation;

        if (this.errors.required.password || this.errors.required.confirmation || this.errors.passwordsDoNotMatch) {
            return null;
        }

        this.loading = true;

        return this.userService
            .resetPassword(this.token, this.password, this.passwordConfirmation)
            .then(() => {
                this.passwordSaved = true;
            })
            .finally(() => {
                this.loading = false;
            });
    }
}
